import { styled } from '@mui/system';
import { useAppSelector } from '../app/hooks';
import TouchableOpacity from './TouchableOpacity';
import checkIcon from '../images/check.svg';
import getThemeLookup from '../selectors/getThemeLookup';

const CheckWrapper = styled(TouchableOpacity)(({ theme }) => {
  const p = useAppSelector(getThemeLookup);

  // p('check', ['color']).color was the old way, we are leaving this in here for backwards compatibility with already themed clients
  const choiceChecked =
    p('check', ['color']).color || p('choiceChecked', ['backgroundColor']).backgroundColor;
  const backgroundColorHover = p('checkHover', ['backgroundColor']).backgroundColor ?? '#C4C4C4';
  const choiceUnChecked =
    p('check', ['backgroundColor']).backgroundColor ||
    p('choiceUnChecked', ['backgroundColor']).backgroundColor;

  const borderRadius = theme.palette.borderRadius ?? 5;
  const size = theme.palette.size ?? 35;

  const isWebkit = navigator.userAgent.indexOf('AppleWebKit') != -1;

  return {
    display: 'flex',
    gap: '0.75em',
    alignItems: 'center',

    '.check-wrapper': {
      height: size,
      width: size,
      minHeight: size,
      minWidth: size,
      position: 'relative',
      borderRadius: borderRadius,
      overflow: 'hidden',
      background: choiceUnChecked,
      transition: 'all 300ms cubic-bezier(0.95, 0.07, 0, 0.92)',
    },

    // The icon of the check-wrapper
    '.check-wrapper:after': {
      content: "''",
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      background: p('choiceChecked', ['color']).color,
      mask: `url(${checkIcon}) no-repeat center`,
      webkitMask: `url(${checkIcon}) no-repeat center`,
      maskSize: '60%',
      webkitMaskSize: '60%',
      opacity: 0,
      transform: 'scale(0.25)',
      transition: 'all 300ms cubic-bezier(0.95, 0.07, 0, 0.92)',
    },

    // This is to remove any possible artifacting
    '.check-wrapper:before': {
      borderRadius: borderRadius,
      content: "''",
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',

      outline: `0px solid ${choiceChecked}`,
      outlineOffset: 0,
      transition: 'all 300ms cubic-bezier(0.95, 0.07, 0, 0.92)',
    },
    '&:hover .check-wrapper': {
      background: backgroundColorHover,
      transitionTimingFunction: 'cubic-bezier(0, 0.71, 0.02, 0.95)',
    },

    '.check-wrapper.checked:before': {
      /* opacity: 1,
      transition: 'opacity 0.3s',
      transitionDelay: '1000ms', */

      outline: `${size / 2}px solid ${choiceChecked}`,
      outlineOffset: size / -2,
    },

    '.checked': {
      background: isWebkit ? choiceChecked : '',
      transition: isWebkit ? 'background 0.1s' : '',
      transitionDelay: isWebkit ? '150ms' : '',
    },

    '.checked:after': {
      opacity: 1,
      transform: 'scale(1)',
    },
  };
});

export default CheckWrapper;
